// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdSenderVerificationTrackingDomainsResult = arrayOf(
  objectOf({
    default_tracking_domain: string,
    tracking_domains: arrayOf(
      objectOf({
        domain: string,
        is_ssl_enabled: boolean,
        is_valid: boolean,
      })
    ),
  })
);

export const isCompaniesCompanyIdSenderVerificationCreateTrackingDomainsResult = objectOf({
  domain: string,
  dns_records: arrayOf(
    objectOf({
      type: string,
      hostname: string,
      value: string,
    })
  ),
});
